import { LDD_GETLISTA_COMPLETE } from "../../const/actionTypes";
import { get } from "lodash";

const initialState = {
  fecha: new Date(1, 1, 1),
  listado: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case LDD_GETLISTA_COMPLETE:
      let ld = get(action, "payload");
      return { ...state, fecha: ld.fecha, listado: ld.listado };
    default:
      return { ...state };
  }
}
